"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const shadows = {
  "overlay": "0px 8px 32px rgba(0, 0, 0, 0.03), 0px 4px 16px rgba(0, 0, 0, 0.03), 0px 2px 8px rgba(0, 0, 0, 0.03), 0px 1px 4px rgba(0, 0, 0, 0.03)",
  "overlayStrong": "0px 8px 32px rgba(3, 3, 3, 0.02), 0px 4px 12px rgba(3, 3, 3, 0.04), 0px 2px 16px rgba(3, 3, 3, 0.06), 0px 0px 48px rgba(3, 3, 3, 0.08)",
  "raised": "0px 1px 2px rgba(0, 0, 0, 0.03), 0px 2px 4px rgba(0, 0, 0, 0.03), 0px 4px 8px rgba(0, 0, 0, 0.03), 0px 8px 16px rgba(0, 0, 0, 0.03)",
  "pressed": "0px 0px 1px rgba(0, 0, 0, 0.04), 0px 1px 2px rgba(0, 0, 0, 0.04), 0px 2px 4px rgba(0, 0, 0, 0.04), 0px 4px 8px rgba(0, 0, 0, 0.04)"
};
exports.default = shadows;